import React from 'react';
import { LogListPanel } from '../components/log-list-panel';

const LogListPage = () => {
  return (
    <>
      <div className="text-lg font-semibold pt-8 pl-6 pb-4">Buku Tarif Log</div>
      <div className="flex-grow overflow-auto px-6">
        <LogListPanel />
      </div>
    </>
  );
};

export default LogListPage;
